module.exports = __webpack_public_path__ + "img/down-to-line.b8a1eb11.svg";